import React from "react";
import {cx} from "../../lib/ClassSet";
import "./ChargeItem.css";
import {Link} from "react-router";
import format from 'date-fns/format'
import ContextMenuTrigger from "../../components/ContextMenuTrigger";
import {formatSalesOrderStatus} from "../../lib/SalesOrderStatus";


const ChargeItem = (props) => {

  let {data} = props;
  let classes = cx({
    "item": true,
    "charge-list-item": true,
    "u-paid": data.get("status") === "paid" 
  })

  let contextClickFn = () => props.onContextMenuClick(data.get("salesOrderId"))

  return (
    <tr className={classes}>
      <td className="field f-id"><Link to={`/sales/orders/${data.get("salesOrderId")}`}>{data.get("salesOrderId")}</Link></td>
      <td className="field f-amount">{data.get("currency")} {data.get("amount")}</td>
      <td className="field f-status current-status">{formatSalesOrderStatus(data.get("status"))}</td>
      <td className="field f-status">{formatKind(data)}</td>
      <td className="field f-date">{formatDueDate(data)}</td>
      <td className="field f-date">{format(data.get("updatedAt"), "MMM D, YYYY")}</td>
      <td className="field f-context"><ContextMenuTrigger active={true} onClick={contextClickFn}/></td>
    </tr>
  )
}

function formatKind(data) {
  switch(data.get("kind")) {
    case "charge": 
      return "Checkout";
    case "subscription_charge": 
      return "Subscription";
    case "payment_terms":
      return `Payment terms ${data.get("paymentTermsDays")} days`;
    default:
      return data.get("kind");
  }
}

function formatDueDate(data) {
  if (data.get("kind") !== "payment_terms") return "n/a";
  return format(data.get("dueAt"), "MMM D, YYYY");
}

export default ChargeItem;